module.exports = __webpack_public_path__ + "static/img/kup-mockup.cb0e281.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kup/kup-mockup.png
// module id = P1JV
// module chunks = 0